export const inputFieldTheme = {
  width: "100%",
  ".MuiInputLabel-root": {
    color: "#727272",
    fontStyle: "normal",
    fontWeight: 400,
  },
  "& input": {
    color: "#000",
    fontSize: "0.9375rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.5rem",
  },
};

export const amountInputTheme = {
  ".MuiInputLabel-root": {
    color: "#727272",
    fontStyle: "normal",
    fontWeight: 400,
  },
  "& input": {
    color: "#000",
    fontSize: 30,
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: 44,
  },
};
